export default {
  title: 'Restaurants test',
  description:
    "Chaque partenaire peut marquer un restaurant comme restaurant test. Il fonctionne comme n'importe quel autre restaurant et n'est jamais facturé. Une alerte Slack est envoyée lorsque ses ventes du mois dépassent le seuil.",
  empty: "Aucun partenaire n'a de restaurant test.",
  columns: {
    partner: 'Partenaire',
    restaurant: 'Restaurant',
    designated: 'Marqué comme test',
    gmv: 'GMV ce mois-ci',
  },
  statuses: {
    live: 'En ligne',
    paused: 'Hors ligne',
    suspended: 'Suspendu',
  },
  gmv: {
    converted: '≈ {{amount}}',
    no_rate: 'Aucun taux de change enregistré',
  },
  actions: {
    remove: 'Retirer la désignation Test',
  },
  toasts: {
    load_error: "Les restaurants test n'ont pas pu être chargés.",
  },
};
